import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { API, pesanGalat } from "../lib/api";
import { KerangkaBaris, KeadaanGalat, KeadaanKosong } from "./kit";

export default function PrioritasHariIni() {
  const [d, setD] = useState(null);
  const [galat, setGalat] = useState(null);
  const muat = () => {
    setGalat(null);
    API.get("/prioritas").then((r) => setD(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(muat, []);

  if (galat) return <KeadaanGalat testid="galat-prioritas" pesan={galat} onCoba={muat} />;
  if (!d) return <KerangkaBaris testid="memuat-prioritas" n={4} />;
  if (!d.jumlah)
    return <KeadaanKosong testid="kosong-prioritas" teks="Bersih. Tidak ada akses yang harus ditutup hari ini." />;

  return (
    <div data-testid="panel-prioritas">
      <div className="panel rounded p-5 border-l-4 border-l-accent">
        <p className="text-lg font-semibold">
          Ada <span className="font-data text-accent">{d.jumlah}</span> akses yang harus ditutup hari ini.
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          <span className="font-data">{d.belum_ada_baris}</span> di antaranya belum punya baris penutupan sama sekali —
          itu yang paling perlu Anda catat lebih dulu di layar Permintaan.
        </p>
        <Link to="/permintaan" data-testid="tautan-ke-permintaan" className="tombol-garis inline-block mt-4 px-4 py-2 rounded text-sm">
          Buka layar Permintaan
        </Link>
      </div>

      <div className="mt-6 space-y-2">
        {d.items.map((it) => (
          <div key={`${it.id}-${it.alasan}`} data-testid={`prioritas-${it.id}`}
            className={`panel rounded p-4 flex flex-wrap items-center gap-x-6 gap-y-2 ${it.terlewat ? "border-l-4 border-l-destructive" : ""}`}>
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent">
              <AlertTriangle size={14} aria-hidden="true" /> {it.alasan}
            </span>
            <span className="text-sm">
              <span className="font-data">{it.orang_kode}</span> — {it.orang_nama}
            </span>
            <span className="text-sm text-muted-foreground">{it.sistem_label} · hak {it.hak}</span>
            <span className="font-data text-sm">{it.umur_hari} hari</span>
            <span className="ml-auto text-xs">
              {it.sudah_ada_baris
                ? <span className="font-data text-muted-foreground">baris {it.nomor_baris} · {it.status_baris}</span>
                : <span className="text-destructive font-medium">belum dicatat</span>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
